import { render } from "./NuovoCliente.vue?vue&type=template&id=786023e2&ts=true"
import script from "./NuovoCliente.vue?vue&type=script&lang=ts"
export * from "./NuovoCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__